"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickersUtilsProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment_1 = __importDefault(require("@date-io/moment"));
var pickers_1 = require("@material-ui/pickers");
/**
 * PickersUtilsProvider provider
 *
 * @description Wrapper component for "MuiPickersUtilsProvider" from "@material-ui/pickers" with "moment" date management library set by default
 *
 * {@link https://github.com/mui-org/material-ui-pickers Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/providers/PickersUtilsProvider Source}
 */
var PickersUtilsProvider = function (_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)(pickers_1.MuiPickersUtilsProvider, __assign({ utils: moment_1.default }, { children: children }));
};
exports.PickersUtilsProvider = PickersUtilsProvider;
